import React, { useState, useEffect } from 'react'
import { Box, SimpleGrid, NumberInput, Flex, Group, Button } from '@mantine/core'
import { useSelector, useDispatch } from 'react-redux'
import { updateOrder } from '../../../../../services/orders'
import { useParams } from 'react-router-dom'
import { getOrderDetail } from '../../../../../store/orderDetail'
import { notificationSuccess, notificationError, loadingNotification, completedLoadingNotification } from '../../../../ui/Notifications'
import { calculation } from '../../../../../services/calculation'
import { validation } from '../../../../../plugins/validation'

const defaultVal = {
  revised_total_weight: 0,
  revised_total_cbm: 0,
}

const formValidation = {
  revised_total_weight: {
    isError: false,
    message: ''
  },
  revised_total_cbm: {
    isError: false,
    message: ''
  },
}

const FormAdjustLogistic = ({ onCloseForm }) => {
  const { logistic } = useSelector(state => state.order_detail)
  const dispatch = useDispatch()
  const params = useParams()
  const orderId = params.order_id
  const [formData, setFormData] = useState(defaultVal)
  const [validationForm, setValidationForm] = useState(formValidation)
  const [loadingForm, setLoadingForm] = useState(false)

  const submitUpdateLogistic = async (form) => {
    setLoadingForm(true)
    setValidationForm(formValidation)

    const validateForm = {
      revised_total_weight: `${form.revised_total_weight}`,
      revised_total_cbm: `${form.revised_total_cbm}`,
    }

    const isError = validation(validateForm, setValidationForm)
    if (isError) {
      setLoadingForm(false)
      return
    }
    
    try {
      const response = await updateOrder(orderId, form)
      if (response.success) {
        notificationSuccess('Update Order Successfully', 'This data has been updated')
        const loadingCalculation = loadingNotification('Waiting Calculation Order', 'Please Wait. . .')
        const responseCalculation = await calculation(orderId)
        if (responseCalculation.success) {
          onCloseForm()
          dispatch(getOrderDetail(orderId))
          completedLoadingNotification(loadingCalculation, 'Calculation Order Successfully', 'This order has been completed in calculation')
        }
      }
    } catch (error) {
      console.log(error)
      const errorMessage = error.response.data.message
      notificationError('Update Order Error', `${errorMessage ? errorMessage : 'Please recheck your form'}`)
    } finally {
      setLoadingForm(false)
    }
  }

  useEffect(() => {
    if (logistic) {
      handleSetForm(logistic)
    }
    // eslint-disable-next-line
  }, [logistic])

  const handleSetForm = (value) => {
    const dataDetail = {
      revised_total_weight: logistic.revisedTotalWeight,
      revised_total_cbm: logistic.revisedTotalCbm,
    }
    setFormData(dataDetail)
  }

  const handleChangeForm = (name, val) => {
    setFormData((oldVal) => ({ ...oldVal, [name]: val}))
  }

  return (
    <Box>
      <SimpleGrid cols={2} verticalSpacing="sm" mb='sm'>
        <Box>
          <NumberInput
            name='total_cbm'
            value={logistic.totalCbm}
            label="Total CBM"
            size='xs'
            withAsterisk
            disabled
          />
        </Box>
        <Box>
          <NumberInput
            name='revised_total_cbm'
            value={formData.revised_total_cbm}
            label="Revised Total CBM"
            placeholder="Input revised total cbm"
            onChange={(val) => handleChangeForm('revised_total_cbm', val)}
            error={validationForm.revised_total_cbm.isError ? `${validationForm.revised_total_cbm.message}` : ''}
            size='xs'
            withAsterisk
          />
        </Box>
        <Box>
          <NumberInput
            name='total_cbm'
            value={logistic.totalWeight}
            label="Total Weight"
            size='xs'
            withAsterisk
            disabled
          />
        </Box>
        <Box>
          <NumberInput
            name='revised_total_weight'
            value={formData.revised_total_weight}
            label="Revised Total Weight"
            placeholder="Input revised total Weight"
            onChange={(val) => handleChangeForm('revised_total_weight', val)}
            error={validationForm.revised_total_weight.isError ? `${validationForm.revised_total_weight.message}` : ''}
            size='xs'
            withAsterisk
          />
        </Box>
      </SimpleGrid>
      <Box mt={20}>
        <Flex justify='flex-end'>
          <Group>
            <Button size='xs' variant="outline" onClick={onCloseForm}>Close</Button>
            <Button size='xs' loading={loadingForm} variant="filled" onClick={() => submitUpdateLogistic(formData)}>Update</Button>
          </Group>
        </Flex>
      </Box>
    </Box>
  )
}

export default FormAdjustLogistic